import { render, staticRenderFns } from "./creator.vue?vue&type=template&id=4b312508&scoped=true"
import script from "./creator.vue?vue&type=script&lang=js"
export * from "./creator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b312508",
  null
  
)

export default component.exports